// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@ces/App/Store/Selectors/SettingsSelectors";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import {
    chain,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Pages/StaticList/Handlers/LoadWishListIfNeeded";

export const xLoadRealTimePrices: typeof LoadRealTimePrices = async props => {
    const { wishList, productInfosByWishListLineId } = props;
    if (
        !wishList.wishListLineCollection?.length ||
        !getSettingsCollection(props.getState()).productSettings.canSeePrices
    ) {
        props.pricingLoaded = true;
        return;
    }

    // XNG-Changes: This is needed because of the override on LoadRealTimePricing handler
    const seePricing = getSettingsCollection(props.getState()).customSetting?.showPricing;
    const { isAuthenticated } = props.getState().context.session;

    if (seePricing === "Secure" && !isAuthenticated) {
        props.pricingLoaded = true;
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: wishList.wishListLineCollection.map(o => ({
                productId: o.productId,
                unitOfMeasure: o.unitOfMeasure,
                qtyOrdered: o.qtyOrdered,
            })),
            onSuccess: realTimePricing => {
                realTimePricing.realTimePricingResults?.forEach(pricing => {
                    for (const wishListLineId in productInfosByWishListLineId) {
                        const productInfo = productInfosByWishListLineId[wishListLineId]!;
                        if (
                            productInfo.productId === pricing.productId &&
                            productInfo.unitOfMeasure === pricing.unitOfMeasure
                        ) {
                            productInfo.pricing = pricing;
                        }
                    }
                });

                props.pricingLoaded = true;
            },
            onError: () => {
                for (const wishListLineId in productInfosByWishListLineId) {
                    productInfosByWishListLineId[wishListLineId]!.failedToLoadPricing = true;
                }
                props.pricingLoaded = true;
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );

    if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.pricingLoaded);
    }
};

replaceInChain(chain, LoadRealTimePrices, xLoadRealTimePrices);
